var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueueLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8.88848C1.49601 8.43376 0 6.64158 0 4.5C0 2.01472 2.01472 0 4.49999 0C6.98527 0 8.99999 2.01472 8.99999 4.49999C8.99999 6.64158 7.50398 8.43375 5.5 8.88848L5.5 16.424C7.18237 16.8058 8.50673 18.1301 8.88848 19.8125L15.9106 19.8125C16.3738 17.5303 18.3916 15.8125 20.8105 15.8125C23.572 15.8125 25.8105 18.0511 25.8105 20.8125C25.8105 23.5739 23.572 25.8125 20.8105 25.8125C18.3916 25.8125 16.3738 24.0947 15.9106 21.8125L8.88848 21.8125C8.43375 23.8165 6.64158 25.3125 4.5 25.3125C2.01472 25.3125 0 23.2978 0 20.8125C0 18.6709 1.49601 16.8787 3.5 16.424L3.5 8.88848ZM20.8105 23.8125C19.1537 23.8125 17.8105 22.4694 17.8105 20.8125C17.8105 19.1557 19.1537 17.8125 20.8105 17.8125C22.4674 17.8125 23.8105 19.1557 23.8105 20.8125C23.8105 22.4694 22.4674 23.8125 20.8105 23.8125Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueLineIcon);
export default __webpack_public_path__ + "static/media/queue-line-icon.8a68c93d5eb2271e38a57111f6f6b41f.svg";
export { ForwardRef as ReactComponent };